
import CTParent from "@/features/triangle-rewards/classes/CTParent";
import PersonalizationApi from "@/features/triangle-rewards/api/PersonalizationApi";
import TriangleRewardsCard from "@/features/triangle-rewards/TriangleRewardsCard.vue";
import BlockGen from "@/features/triangle-rewards/classes/BlockGen";
import offers from "@/features/triangle-rewards/data/offers.json";
import OfferListItem from "@/features/triangle-rewards/OfferListItem.vue";
import router from "@/router";

const state = {
/*	isLoggedIn: false,
	triangleID: null,*/
	loadedOffers: null
}

const getters = {
	isLoggedIn() {
		return router.currentRoute?.query?.isCustomerLoggedIn === 'true';
	},
	triangleID() {
		return router.currentRoute?.query?.custID;
	},

	offerViewMode(state, getters, rootState, rootGetters) {
		return rootGetters['landingPage/currentFlyer'].flyerType;
		//return rootState.landingPage.currentFlyer?.flyerType;
	},
	personalizedViewMode(state, getters, rootState, rootGetters) {
		return rootGetters['landingPage/currentFlyer']?.flyerCategory;
		//return rootState.landingPage.currentFlyer?.flyerType;
	},
	offersPage(state, getters, rootState) {
		return rootState.pages.find((page) => {
			return page.id === 'triangleRewards';
		})
	},

	isSignedIn(state, getters){
		return getters.isLoggedIn && getters.triangleID;
	},

	//Is the user logged into Canadian Tire
	isLoggedIntoCT(state, getters){
		return !!getters.isLoggedIn;
	},

	hasTriangleID(state, getters){
		return !!getters.triangleID;
	},
	canViewTriangleRewards(state, getters) {
		const today = new Date();
		const dayOfWeek = 2; //Tuesday
		return getters.isLoggedIntoCT && getters.hasTriangleID && !(getters.offerViewMode !== 'live' && today.getDay() === dayOfWeek);// && getters.offerViewMode === 'live';
	},
	canViewPersonalizedBanner(state, getters) {
		return getters.isSignedIn && getters.hasTriangleID && getters.personalizedViewMode?.includes('Weekly') ;
	},
	canViewPreviewText(state, getters) {
		const today = new Date();
		const dayOfWeek = 2; //Tuesday
		const {isLoggedIntoCT, hasTriangleID, offerViewMode} = getters;
        const isTuesday = today.getDay() === dayOfWeek 

		return isLoggedIntoCT && hasTriangleID && ((offerViewMode === 'preview' && isTuesday ) || (offerViewMode === 'preview' || isTuesday ))
		 && !(offerViewMode === 'live' && isTuesday);
	},
	currentDeal(state, getters, rootState, rootGetters) {
		const deal = rootGetters["landingPage/currentFlyer"]?.title; //rootState.landingPage?.currentFlyer?.title  //rootState["landingPage/currentFlyer"]?.title;
		if(deal) {
			return parseInt(deal.match(/([0-9])\w+/g), 10);
		}
	},
	currentStore(state, getters, rootState) {
		return rootState.currentStore;
	},
	/*language(state, getters, rootState) {
		return rootState.language;
	},*/
	hasOffers(state) {
		return !!state.loadedOffers;
	},
	triangleOffers(state) {
		if(state.loadedOffers) return state.loadedOffers.products;
		const fake = [];
		for(let i=0; i < 10; i++){
			const ri = Math.round((offers.length - 1) * Math.random());
			const item = offers.splice(ri, 1)[0];
			item.isFake = true;
			fake.push(item);
		}
		return fake;
	},
	isFakeOffers(state) {
		return !state.loadedOffers;
	},

	registrationUrl(state, getters, rootState, rootGetters) {
		const lang = rootGetters.language;
		return lang === 'en' 
			? 'https://can01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fcustomerauth.triangle.com%2Fen%2Fsso%2Ftriangle-registration.html%3Fgig_ssoToken%3Dus1_tk1.-aGi5A5fPZ4GC5IWZZ4dlzSFp4Dy8EvwCl3vXiWO1Go%26gig_refClient%3Dctr%252Fweb%26gig_lang%3Den%26gig_clp%3Dtrue%26gig_sourceURL%3Dhttps%253A%252F%252Fwww.canadiantire.ca%252Fen.html&data=05%7C02%7CLouise.Goguen%40cantire.com%7Ced4df9756219426fc0f808ddc47ad834%7Cbd6704ff1437477c9ac9c30d6f5133c5%7C0%7C0%7C638882754081543129%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=oxeQbU%2FC1Ifp1CKjvZM8j5M5MsYI2GtSii0UFGHOR2A%3D&reserved=0'
			: 'https://can01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fcustomerauth.triangle.com%2Ffr%2Fsso%2Ftriangle-registration.html%3Fgig_ssoToken%3Dus1_tk1.O8zsTJNFzDddWipo-ZdAtXXSeTXdDcBD-DXSuz8OGng%26gig_refClient%3Dctr%252Fweb%26gig_lang%3Dfr%26gig_clp%3Dtrue%26gig_sourceURL%3Dhttps%253A%252F%252Fwww.canadiantire.ca%252Ffr.html&data=05%7C02%7CLouise.Goguen%40cantire.com%7Ced4df9756219426fc0f808ddc47ad834%7Cbd6704ff1437477c9ac9c30d6f5133c5%7C0%7C0%7C638882754081569449%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=MXB5zdYNVYspUOXHyW7O3vncYfXLngj%2FX6nrQfdGWU4%3D&reserved=0';
	},

	triangleSignInUrl(state, getters, rootState, rootGetters) {
		const lang = rootGetters.language;
		const urls = {
			en: 'https://can01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fcustomerauth.triangle.com%2Fen%2Fsso%2Ftriangle-signin.html%3Fgig_ssoToken%3Dus1_tk1.2Wpzgt6ouwP2wv5LBKLklnWeedMk12f0wuoct2KcRFc%26gig_refClient%3Dctr%252Fweb%26gig_lang%3Den%26gig_clp%3Dtrue%26gig_sourceURL%3Dhttps%253A%252F%252Fwww.canadiantire.ca%252Fen.html%26gig_QMSession%3D28699fff2d6e9402071a6fad111a1686%26gig_QMUser%3D146830f1ea88257e5d6695f8711e6e17&data=05%7C02%7CLouise.Goguen%40cantire.com%7Ced4df9756219426fc0f808ddc47ad834%7Cbd6704ff1437477c9ac9c30d6f5133c5%7C0%7C0%7C638882754081507499%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=fMPIRapLcvrBopz7NkN%2BgKHmn1dELStpWNIszYCgqeM%3D&reserved=0',
			fr: 'https://can01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fcustomerauth.triangle.com%2Ffr%2Fsso%2Ftriangle-signin.html%3Fgig_ssoToken%3Dus1_tk1.dDBxIDW7pwZw-HZZ5yW8N1R7XJfdgJAq7Xucy8qCL_E%26gig_refClient%3Dctr%252Fweb%26gig_lang%3Dfr%26gig_clp%3Dtrue%26gig_sourceURL%3Dhttps%253A%252F%252Fwww.canadiantire.ca%252Ffr.html&data=05%7C02%7CLouise.Goguen%40cantire.com%7Ced4df9756219426fc0f808ddc47ad834%7Cbd6704ff1437477c9ac9c30d6f5133c5%7C0%7C0%7C638882754081523803%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=HONgCiXx8SilqiBJBhFMKanmQKZG8y4b6R6wd8IfO5Y%3D&reserved=0'
		};
		return urls[lang] || urls.en;
	}
}

const actions = {
	async loadPersonalizedAds( { getters,rootGetters} ) {
		const dealNo = getters.currentDeal;
		const storeId = getters.currentStore;
			try {
				const data = await PersonalizationApi.GetPersonalizedAd(getters.triangleID, dealNo, storeId, rootGetters.language);
				//console.log('what is data', data)
				return data || null
			} catch (e) {
				return null
			}
	},
	triggerUserDialog({ getters, rootState }) {
		console.log('Trigger User Dialog');
		if(getters.isLoggedIn && !getters.triangleID){
			CTParent.ShowTriangleLink();
		} else if(!getters.isLoggedIn) {
			const deal = getters.currentDeal;
			const index = rootState.currentPageIndex + 1;
			CTParent.ShowCTLogin(index? index: null, deal?deal:null);
		}
	},

	async loadOffers( {commit, state, getters, dispatch,rootGetters} ) {
		// console.log('loadOffers')
		const dealNo = getters.currentDeal;
		const storeId = getters.currentStore;
		if((dealNo && storeId && getters.canViewTriangleRewards && !state.loadedOffers) || ( state.loadedOffers && ((state.loadedOffers.dealNo !== dealNo) || (state.loadedOffers.customerId !== getters.triangleID)) && getters.canViewTriangleRewards)) {
			// console.log('Attempt to load triangle-rewards')
			try {
				const offers = await PersonalizationApi.GetOffers(getters.triangleID, dealNo, storeId, rootGetters.language);
				commit('APPLY_OFFERS', offers);
			} catch (e) {
				commit('APPLY_OFFERS', null);
			}
		}
		dispatch('updateOfferBlocks');
	},

	updateOfferBlocks({ getters, rootState }) {
		const page = getters.offersPage;
		const offers = getters.triangleOffers;
		const unitWidth = page.unitWidth;
		const unitHeight = page.unitHeight;
		page.blocks.length = 0;
		
		if (!getters.isLoggedIntoCT || !getters.triangleID || getters.canViewPreviewText){
			page.blocks.push(BlockGen.GenBlock(3, 4, unitWidth, unitHeight, {}, {id:'triangleRewards_card', type: 'component', component: TriangleRewardsCard, hasOffers: getters.hasOffers}));
		} else {
			page.blocks.push(BlockGen.GenBlock(3, 1, unitWidth, unitHeight, {}, {id:'triangleRewards_card', type: 'component', component: TriangleRewardsCard, hasOffers: getters.hasOffers}));
			if(page) {
				if (offers[0].isFake) {
					const pageIndex = rootState.pages.findIndex(page => page.id === 'triangleRewards')
					rootState.pages.splice(pageIndex, 1);
					} else {
						for(let i=0; i < offers.length; i++) {
							page.blocks.push(BlockGen.GenBlock(1, 1, unitWidth, unitHeight, {}, {type: 'component', component: OfferListItem, componentData: offers[i], index: i + 1 }));
						}
					}
				
				//page.blocks = blocks;
			}
		}
	}
}

const mutations = {
/*	SET_LOGGED_IN_STATE(state, val) {
		state.isLoggedIn = val;
	},

	SET_TRIANGLE_ID(state, val) {
		state.triangleID = val;
	},*/

	APPLY_OFFERS(state, offers) {
		if(offers?.products?.length){
			state.loadedOffers = offers;
		} else {
			state.loadedOffers = null;
		}
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
